export const settingsConstant = {
  CHAGE_THEME: 'CHAGE_THEME',
  UPDATE_IS_SPECIALITY: 'UPDATE_IS_SPECIALITY',
  CHANGE_BASE_CLASS: 'CHANGE_BASE_CLASS'
};
